import React, { Component } from 'react';
import { connect } from 'react-redux';
import './VideoPreview.scss';
import ReactPlayer from 'react-player'
import { findDOMNode } from 'react-dom'
import screenfull, { Screenfull } from "screenfull";


//icon
import expandIcon from '../../assets/expand.png';
import closeIcon from '../../assets/round_close.png';
import { goBack } from 'connected-react-router';

/**
 * Automatic backward to the homescreen, if a pages is navigated to, without a searchterm.
 */
class VideoPreview extends Component<{ item: any, back: any }, {}> {
  private player: any;


  openFullScreen() {

  }
  /**
   * Main render method
   */
  render() {
    return (
      <div className="videopreview">
        <div className="header">
          <div className="title">{this.props.item.name}</div>
          <div className="navigation">
            <div className="expand-container" onClick={() => {
              const node: any = findDOMNode(this.refs.player);
              if (screenfull && screenfull.enabled) {
                screenfull.request(node)
              }
            }}>
              <img src={expandIcon} className="expandicon" />
             groß
                </div>
            <div className="close-container" onClick={() => {
              this.props.back();
            }}>
              <img src={closeIcon} className="closeicon" />
              zurück
              </div>
          </div>
        </div>
        <div className="container">
          <ReactPlayer
            ref='player'
            className="react-player"
            url={this.props.item.contentUrl}
            width="100%"
            height="100%"
            controls={true} />

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    item: state.result.currentItem
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    back() {
      dispatch(goBack());
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoPreview);